"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseThemeConfig = exports.parsePlainConfig = exports.getAlgorithmString = exports.algorithmMap = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _antd = require("antd");
var _excluded = ["algorithm"],
  _excluded2 = ["algorithm"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var algorithmMap = exports.algorithmMap = {
  dark: _antd.theme.darkAlgorithm,
  compact: _antd.theme.compactAlgorithm
};
var getAlgorithmString = exports.getAlgorithmString = function getAlgorithmString(algorithm) {
  var _Object$entries$find;
  return (_Object$entries$find = Object.entries(algorithmMap).find(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      value = _ref2[1];
    return value === algorithm;
  })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[0];
};
var parsePlainConfig = exports.parsePlainConfig = function parsePlainConfig(config) {
  var algorithm = config.algorithm,
    rest = (0, _objectWithoutProperties2.default)(config, _excluded);
  if (!algorithm) return rest;
  var parsedAlgorithms = Array.isArray(algorithm) ? algorithm.map(getAlgorithmString) : getAlgorithmString(algorithm);
  return _objectSpread(_objectSpread({}, rest), {}, {
    algorithm: parsedAlgorithms
  });
};
var parseThemeConfig = exports.parseThemeConfig = function parseThemeConfig(config) {
  var algorithm = config.algorithm,
    rest = (0, _objectWithoutProperties2.default)(config, _excluded2);
  if (!algorithm) return rest;
  var parsedAlgorithms = Array.isArray(algorithm) ? algorithm.map(function (item) {
    return algorithmMap[item];
  }).filter(Boolean) : algorithmMap[algorithm];
  return _objectSpread(_objectSpread({}, rest), {}, {
    algorithm: parsedAlgorithms
  });
};